import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <a href="#" className="logo">食光</a>
            <p>分享简单美味的食谱，激发家庭烹饪的乐趣。从快捷便餐到特别场合，这里都有。</p>
          </div>
          <div className="footer-links">
            <h4>探索</h4>
            <ul>
              <li><a href="#">首页</a></li>
              <li><a href="#">食谱</a></li>
              <li><a href="#">分类</a></li>
              <li><a href="#">关于</a></li>
            </ul>
          </div>
          <div className="footer-links">
            <h4>分类</h4>
            <ul>
              <li><a href="#">亚洲风味</a></li>
              <li><a href="#">意式料理</a></li>
              <li><a href="#">甜品点心</a></li>
              <li><a href="#">快捷美食</a></li>
            </ul>
          </div>
          <div className="footer-links">
            <h4>帮助</h4>
            <ul>
              <li><a href="#">常见问题</a></li>
              <li><a href="#">联系我们</a></li>
              <li><a href="#">隐私政策</a></li>
              <li><a href="#">使用条款</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>2024 食光 版权所有</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
